import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b668a47"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "活动推广信息配置", -1))
const _hoisted_2 = { class: "a_form" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_4 = {
  class: "subtitle",
  style: {"margin-top":"20px"}
}
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { style: {"padding-left":"20px"} }
const _hoisted_7 = { style: {"text-align":"center","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    model: _ctx.formState,
    rules: _ctx.rules,
    ref: "formRef",
    "label-col": { style: { width: '100px' } }
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_form_item, {
          label: "子任务说明",
          name: "taskMemo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: _ctx.formState.taskMemo,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.taskMemo) = $event)),
              placeholder: "请输入",
              maxlength: 255,
              allowClear: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _hoisted_3,
        _createVNode(_component_a_form_item, {
          label: "推广URL",
          name: "performUrl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.performUrl,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.performUrl) = $event)),
              placeholder: "请输入",
              maxlength: 255,
              allowClear: "",
              size: "small"
            }, null, 8, ["value"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createTextVNode(" 扩展字段配置 "),
          _createVNode(_component_a_popover, null, {
            content: _withCtx(() => [
              _createTextVNode(" 配置活动推广需要传输的参数，例如：[扩展字段名称：商品名称，扩展字段值：悦鲜活 ] ")
            ]),
            default: _withCtx(() => [
              _createVNode(_component_QuestionCircleOutlined, { style: {"margin-left":"5px","font-size":"14px"} })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formState.extraList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "a_form",
            key: item
          }, [
            _createVNode(_component_a_form_item, {
              label: '扩展字段' + (index + 1) + '名称',
              name: item.code
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.extraList[index].name,
                  "onUpdate:value": ($event: any) => ((_ctx.formState.extraList[index].name) = $event),
                  placeholder: "请输入",
                  maxlength: 30,
                  allowClear: "",
                  size: "small",
                  onChange: _ctx.changeExtr
                }, null, 8, ["value", "onUpdate:value", "onChange"])
              ]),
              _: 2
            }, 1032, ["label", "name"]),
            _createVNode(_component_a_form_item, {
              label: '扩展字段' + (index + 1) + '值',
              name: item.code
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.extraList[index].value,
                  "onUpdate:value": ($event: any) => ((_ctx.formState.extraList[index].value) = $event),
                  placeholder: "请输入",
                  maxlength: 30,
                  size: "small",
                  onChange: _ctx.changeExtr,
                  allowClear: ""
                }, null, 8, ["value", "onUpdate:value", "onChange"])
              ]),
              _: 2
            }, 1032, ["label", "name"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _ctx.add
          }, {
            default: _withCtx(() => [
              _createVNode(_component_PlusOutlined),
              _createTextVNode(" 新增扩展字段 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "link",
            style: {"color":"#f00"},
            onClick: _ctx.del
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DeleteOutlined),
              _createTextVNode(" 删除扩展字段 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_button, {
            style: {"width":"100px"},
            onClick: _ctx.upperLevel
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 上一步 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.save,
            style: {"width":"100px","margin":"0 40px"},
            loading: this.$store.state.loadingStatus
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.save('publish'))),
            style: {"width":"100px"},
            loading: this.$store.state.loadingStatus
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存并发布 ")
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}